export default __webpack_public_path__ + "static/media/rounded-corners.7d7fdf24.webp";